import config from '~/config';

export const canManageDatabase = config.isLocal || config.isTest || config.isFeatureBranch;
